import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import { paddingBuilder, themeSpace } from 'styles/themeUtils';

const AdvantagesListRoot = styled.ul`
  ${paddingBuilder.left(2.875)}
  margin-bottom: ${themeSpace(2.5)};

  & > :last-child {
    margin-bottom: 0;
  }

  ${tablet768`
    margin-bottom: 0;
  `}
`;

AdvantagesListRoot.displayName = 'AdvantagesListRoot';

export default AdvantagesListRoot;
